<template>
  <div @click="toggleDarkTheme" class="icon" :class="{ 'icon--dark' : darkMode, 'icon--light': !darkMode }">
    <apio-icon size="18" :name="iconClass" lightModeColour="cyan" darkModeColour="white"  />
  </div>
</template>

<script>
export default {
  name: "DarkLightModeToggle",
  computed: {
    isMobile() {  
      return this.$vuetify.breakpoint.xs;
    },
    darkMode: {
      get: function () {
        return this.$vuetify ? this.$vuetify.theme.dark : false;
      },
      set: function () {
        this.$store.commit("set", ["darkMode", true])
      },   
    },
    iconClass() {
      return this.darkMode ? "ui-dark-mode" : "ui-light-mode";
    },
  },
  methods: {
    toggleDarkTheme() {
      if (this.$vuetify) {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        this.$store.commit("set", ["darkMode", this.$vuetify.theme.dark])
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .icon {
    height: 32px;
    width: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;

    &--dark {
      background: var(--apio-purple);
      border: 1px solid var(--apio-purple);
    }

    &--light {
      border: 1px solid var(--apio-cyan)
    }

    &:hover {
      cursor: pointer;
    }
  }
</style>